// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Netherlands from '../_raw/flag/icon_flag_netherlands.png';

export default () => <img src={Netherlands} alt="Netherlands" />;
